import request from '@/utils/request'

export function actionPinata(data) {
  return request({
    url: 'api/v1/pinata/update',
    method: 'post',
    data: data
  })
}

export function pinata(data) {
  return request({
    url: 'api/v1/pinata/list',
    method: 'post',
    data: data
  })
}

export function collectionRoomProgress(data) {
  return request({
    url: 'api/v1/collectionRoomProgress/list',
    method: 'post',
    data: data
  })
}

export function actionCollectionRoomProgress(data) {
  return request({
    url: 'api/v1/collectionRoomProgress/update',
    method: 'post',
    data: data
  })
}

export function delCollectionRoomProgress(data) {
  return request({
    url: 'api/v1/collectionRoomProgress/del',
    method: 'post',
    data: data
  })
}
